import { APIClient } from "./api_helper";
import * as url from "./realtime_url_helper";


const api_ai = new APIClient();

// endpoint for the api ai
export const getCategorySearchAi = (word:string) => api_ai.get(url.GET_CATEGORY_SEARCH_AI, {query:word});


